define(function(require) {
  // template
  const tpl = require('civicsViews/new_attachments/templates/t_cpv_attachment_group_list.hbs');

  // views
  const AttachmentGroupRowView = require('civicsViews/new_attachments/v_lov_attachment_group_row.js');
  const AddAttachmentView = require('civicsViews/new_attachments/upload_modal/v_cpv_add_attachments');

  // models & collections
  const AttachmentCollection = require('civicsCollections/attachment_collection');
  const DocumentTypeCollection = require('civicsCollections/document_type_collection');
  const AttachmentConstraintsCollection = require('civicsCollections/attachment_constraints_collection');
  const IpsModel = require('civicsBase/ipsModel');

  // utils
  const ViewManager = require('civicsUtils/view_manager');
  const ModalRegion = require('civicsUtils/modal_region.js');

  const Radio = require('backbone.radio');
  const AttachmentChannel = Radio.channel('addAttachmentChannel');

  return Marionette.CompositeView.extend({
    template: tpl,

    ui: {
      addButton: '.attachment-group-add'
    },
    events: {
      'click @ui.addButton': 'openUploadModal'
    },
    childEvents: {
      'attachments:delete': 'onDeleteAttachment'
    },
    className: 'list-group',
    childViewContainer: '.row-region',
    childView: AttachmentGroupRowView,
	childViewOptions: function (model, index) {
		var attach = this.isOptionalFileView ? this.optionalAttachments : this.attachmentMap[model.get('name')];
		return {
			config: this.config,
			catalog: this.catalog,
			modalRegion: this.modalRegion,
			attachments: attach,
      // nonConstraintAttachments: this.nonConstraintAttachments,
			rawAttachments: this.rawAttachments,
			isOptionalFileView: this.isOptionalFileView,
			isAddProcess: this.isAddProcess,
			isReviewProcess: this.isReviewProcess,
			globalCanAdd: this.globalCanAdd,
			parentMoniker: this.parentMoniker,
			parentPrimaryKey: this.parentPrimaryKey,
			availableConstraints: this.isOptionalFileView ? this.constraints : null,
			statusCheckRequirements: this.statusCheckRequirements,
			usesStatusCheckRequirements: this.usesStatusCheckRequirements,
			attachment_index: index,
      viewName: this.viewName,
		};
	},
    initialize: function(options) {
      this.config = options.config;
      this.catalog = options.catalog;
      this.modalRegion = options.modalRegion;
      this.isReviewProcess = options.isReviewProcess;
      this.isAddProcess = options.isAddProcess;
      this.globalCanAdd = options.globalCanAdd;
      this.groupLabel = options.groupLabel;
      this.constraints = options.constraints;
      this.attachments = options.attachments;
      this.rawAttachments = options.rawAttachments;
      this.isOptionalFileView = options.isOptionalFileView;
      this.parentMoniker = options.parentMoniker;
      this.parentPrimaryKey = options.parentPrimaryKey;
      this.statusCheckRequirements = options.statusCheckRequirements;
      this.usesStatusCheckRequirements = options.usesStatusCheckRequirements;
      this.viewName = options.viewName;
      this.requiredConstraints = options.requiredConstraints;

      if(this.isOptionalFileView) {
        this.optionalAttachments = this.getOptionalAttachments();
        this.documentTypeCollection = this.getOptionalDocumentTypes();
      }

      this.setConstraints();
      this.attachmentMap = this.mapAttachmentsToConstraints();

    },
    getOptionalDocumentTypes: function() {
      var self = this;
      var collection = new DocumentTypeCollection();
      self.constraints.each(function(constraint){
        var doctype = new IpsModel();
        doctype.set('attributes',constraint.get('attributes'));
        doctype.set('description',constraint.get('description'));
        doctype.set('name',constraint.get('name'));
        doctype.set('permissions',constraint.get('permissions'));
        collection.add(doctype);
      });
      return collection;
    },
    hasAddPermissionForOptionalFiles: function() {
      var self = this;

      var canUpload = false;
      self.constraints.each(function(constraint) {
        var permissions = constraint.get('permissions').toJSON();
        if(permissions.add) {
          canUpload = true;
        }
      });
      return canUpload;
    },
    setConstraints: function() {
      var self = this;
      if (self.isOptionalFileView) {
        self.collection = new AttachmentConstraintsCollection();
        self.collection.add(new Backbone.Model({
          "optional": true
        }));

      } else {
        self.collection = new AttachmentConstraintsCollection();
        self.constraints.each(function(constraint) {
          self.collection.add(constraint);
        });
      }
    },
    mapAttachmentsToConstraints: function(constraint) {
      var self = this;
      var attachmentMap = {};
      self.constraints.each(function(constraint){
        attachmentMap[constraint.get('name')] = self.getAttachmentsByConstraint(constraint);
      });
      return attachmentMap;
    },
    getAttachmentsByConstraint: function(constraint) {
      var coll = new AttachmentCollection();
      var constraintName = constraint.get('name');
      this.attachments.each(function(attachment) {
        var doctype = attachment.get('documentType');
        if (doctype != null && doctype.get('name') == constraintName) {
          coll.add(attachment);
        }
      });

      coll.sort('addedDateTime', 'ASC');

      return coll;
    },
    getOptionalAttachments: function() {
      var documentTypesRequired = [];

       if(this.requiredConstraints) {
         this.requiredConstraints.each(function(constraint) {
           documentTypesRequired.push(constraint.get('name'));
         });
       }


      //this.nonConstraintAttachments = new AttachmentCollection();

      var optionalAttachments = new AttachmentCollection();

      this.attachments.each(function(attachment) {
        var doctype = attachment.get('documentType');
        if (doctype != null && !documentTypesRequired.includes(doctype.get('name'))) {
          // if(!attachment.get('nonConstraintAttachment')) {
            optionalAttachments.add(attachment);
          // }
          // else {
          //
          //   attachment.set('nonConstraintAttachment', true);
          //   this.nonConstraintAttachments.add(attachment);
          // }
        }
      }.bind(this));

      optionalAttachments.sort('addedDateTime', 'ASC');

      return optionalAttachments;
    },
    openUploadModal: function(e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      e.stopPropagation();
      if (this.addAttachmentView) {
        this.addAttachmentView.destroy();
      }

      this.addAttachmentView = new AddAttachmentView({
        config: this.config,
        catalog: this.catalog,
        modalRegion: this.modalRegion,
        isAddProcess: this.isAddProcess,
        documentTypeCollection: this.documentTypeCollection,
        existingAttachmentCollection: this.optionalAttachments,
        parentMoniker: this.parentMoniker,
        parentPrimaryKey: this.parentPrimaryKey,
        isOptionalFileView: this.isOptionalFileView,

      });
      this.modalRegion.show(this.addAttachmentView);
      this.modalRegion.showModal();

      return false;
    },
    onDeleteAttachment: function(view,model) {
      var self = this;
      self.attachments.remove(
        self.attachments.get({cid: model.get('cid')})
      );

      AttachmentChannel.trigger('attachments:delete', model);

    },
    onRender: function() {},
    onShow: function() {},
    templateHelpers: function() {
      var self = this;
      var showAddButton = self.globalCanAdd && self.isOptionalFileView && self.hasAddPermissionForOptionalFiles();
      return {
        showAddButton: showAddButton,
        showGroupLabel: !self.isReviewProcess,
        groupLabel: self.groupLabel
      };
    }
  });
});
